export const AppConfig = {
  plainBaseUrl: process.env.REACT_APP_API_BASE_URL,
  apiProtocol: process.env.REACT_APP_API_PROTOCOL,
  apiBaseUrl:
    process.env.REACT_APP_API_PROTOCOL +
    process.env.REACT_APP_API_BASE_URL +
    '/api',

  wsBaseUrl:
    process.env.REACT_APP_WS_PROTOCOL +
    process.env.REACT_APP_API_BASE_URL +
    '/cable',

  syncfusionLicenseKey: process.env.REACT_APP_SYNCFUSION_LICENSE_KEY,
  googleMapsAPIkey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
};
